import React, { useContext, useEffect, useState } from "react";
import "../../../leaveNotes/leaveNotePopup.css";
import "../subdepartment/SubdepartmentPopup.css";
import CloseIcon from "../../../../images/CloseIcon.svg";
import "../../../hooks/imagePreview.css";
import "../leaveType/LeavePopup.css";
import Plus from "../../../../images/Plus.png";
import AuthContext from "../../../context/auth-context";
import { Fetchdata } from "../../../hooks/getData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StaffContext from "../staffState/StaffContext";
import UpperbarContext from "../../../context/upperbar-context";
import $ from "jquery";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import NepaliDate from "nepali-date-converter";
import { GetNepaliDate } from "../../../hooks/dateConvertor";

export default function Basic() {
  const { User } = useContext(AuthContext);
  const { appURL, mode ,dateMode} = useContext(UpperbarContext);
  const {
    staffPopup,
    setStaffPopup,
    staffEditPopup,
    setStaffEditPopup,
    currentStep,
    setStep,
    staffFormValue,
    setStaffFormValue,
    staffFormError,
    setStaffFormError,
    staffValue,
    isUploaded,
    setIsUploaded,
    typeFile,
    setTypeFile,
    image,
    setImage,
    editIsSubmit,
    setEditIsSubmit,
    checkedList,
    setCheckedList,
    managerChecked,
    setManagerChecked,
    notWorking,
    setNotWorking,
    departmentList,
   
   
    titleId,
    stfList,
   
  } = useContext(StaffContext);
  const [DFlag, setDFlag] = useState("N");
  const getEnglishDate = (date) => {
    let nDate = new NepaliDate(date);

    let eDate = nDate.getAD();

    let enMonth = eDate.month + 1;
    let enM = enMonth < 10 ? `0${enMonth}` : enMonth;

    let enDat = eDate.date < 10 ? `0${eDate.date}` : eDate.date;
    return `${eDate.year}-${enM}-${enDat}`;
  };
  const closePopUp = (e) => {
    setStaffEditPopup(false);
    // setManagerChecked(false);
    setStaffFormError({});
    $(".editStaffPopBg").fadeOut(500);
    $(".editStaffPop").slideUp(500);
    setEditIsSubmit(false);
  };

  const [data, setData] = useState([]);

  const handleDOB = ({ bsDate }) => {
    // setFromDate(bsDate);
    let name = "dateOfBirth";
    setStaffFormValue({ ...staffFormValue, [name]: bsDate });
  };
  const handleEnroll = ({ bsDate }) => {
    // setFromDate(bsDate);
    let name = "enrollDate";
    setStaffFormValue({ ...staffFormValue, [name]: bsDate });
  };
  // const handleLeaveDate = ({ bsDate }) => {
  //   // setFromDate(bsDate);
  //   let name = "leaveDate";
  //   setStaffFormValue({ ...staffFormValue, [name]: bsDate });
  // };

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.type == "checkbox" ? target.checked : target.value;
    if (name === "department") {
      staffFormValue.subDepartment = "";
      staffFormValue.designation = "";
    }
    if (name === "subDepartment") {
      staffFormValue.designation = "";
    }
    setStaffFormValue({ ...staffFormValue, [name]: value });
  };

  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
    brnchList();
  }, []);

  const brnchList = () => {
    const params = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: -1,
      Flag: "S",
      BranchID: User.BranchID,
      FiscalID: User.FiscalID,
      IsActive: "-1",
      Type: "POST",
      FetchURL: `${appURL}api/olite/admin/branch`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";
        setBranchList(postResult);
      } else {
        setBranchList([]);
      }
    });
  };

  // const handleChecked = (e) => {
  //   let indexList = checkedList ? checkedList.indexOf(e.target.value) : -1;
  //   if (indexList === -1) {
  //     checkedList.push(e.target.value);
  //   } else {
  //     setCheckedList(checkedList.filter((list) => list !== e.target.value));
  //   }
  // };

  const handleChecked = (e) => {
    // Destructuring
    const { value, checked } = e.target;

    // Case 1 : The user checks the box
    if (checked) {
      checkedList.push(e.target.value);
    }

    // Case 2  : The user unchecks the box
    else {
      setCheckedList(checkedList.filter((list) => list !== e.target.value));
    }
  };
  let uniqueCheckedList = [...new Set(checkedList)];

  const handleCheckList = (e) => {
    let uniqueCheckedList = [...new Set(checkedList)];
    uniqueCheckedList = uniqueCheckedList.filter((item) => item);
    staffFormValue.days = uniqueCheckedList.toString();
  };



  const formNext = (e) => {
    handleCheckList();
    e.preventDefault();
    setStaffFormError(validate(staffFormValue));
    setEditIsSubmit(true);
  };
  useEffect(() => {
    if (Object.keys(staffFormError).length === 0 && editIsSubmit) {
      const dataForm = {
        AuthCode: User.AuthCode,
        ComID: User.ComID,
        UserID: User?.UserID,
        Flag: "U",
        StaffID: titleId,
        UserCode:
          staffFormValue.userName !== " " ? staffFormValue.userName : " ",
        DeviceCode:
          staffFormValue.deviceCode !== " " ? staffFormValue.deviceCode : "0",
        FirstName:
          staffFormValue.firstName !== " " ? staffFormValue.firstName : " ",
        MiddleName:
          staffFormValue.middleName !== "" ? staffFormValue.middleName : " ",
        LastName:
          staffFormValue.lastName !== " " ? staffFormValue.lastName : " ",
        UserName:
          staffFormValue.userName !== " " ? staffFormValue.userName : " ",
        // Password: "easy@123",
        Email: staffFormValue.email !== " " ? staffFormValue.email : " ",
        Contact: staffFormValue.contact !== " " ? staffFormValue.contact : " ",
        
       
        CitizenshipNo:
          staffFormValue.citizenshipNo !== " "
            ? staffFormValue.citizenshipNo
            : " ",
        PAN: staffFormValue.pan !== " " ? staffFormValue.pan : " ",
      
        Gender: staffFormValue.gender !== " " ? staffFormValue.gender : " ",
        Image: image !== null ? image.split(",")[1] : "",
        WorkingStatus: notWorking ? "N" : "Y",
        JobType: staffFormValue.jobType !== " " ? staffFormValue.jobType : " ",
      
        LeaveDate: "",
        EnrollDate:
        dateMode === "np" && staffFormValue.enrollDate
          ? getEnglishDate(staffFormValue.enrollDate)
          : staffFormValue.enrollDate,
     
        Department:
          staffFormValue.department !== " " ? staffFormValue.department : " ",
        Designation:
          staffFormValue.designation !== " " ? staffFormValue.designation : " ",
        
        FetchURL: `${appURL}api/olite/admin/user`,
        Type: "POST",
      };

      Fetchdata(dataForm).then(function (result) {
        if (result.StatusCode === 200) {
          setStaffEditPopup(false);
          stfList();
          $(".editStaffPopBg").fadeOut(500);
          $(".editStaffPop").slideUp(500);
          toast.success(result.Message, {
            style: {
              color: "green",
              fontSize: "13px",
            },
            theme: "light",
          });
        } else {
          toast.error("Error: " + result.Message, {
            style: {
              color: "red",
              fontSize: "13px",
            },
            theme: "light",
          });
        }
      });
    }

    setEditIsSubmit(false);
  }, [staffFormError]);

  const validate = (values) => {
    const errors = {};
    const numv = /^[0-9]+$/i;
    const digits = /^\d{10}$/;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.firstName) {
      errors.firstName = mode === "en" ? "Required" : "आवश्यक छ";
    }
    if (!values.lastName) {
      errors.lastName = mode === "en" ? "Required" : "आवश्यक छ";
    }

    if (!values.userName) {
      errors.userName = mode === "en" ? "Required" : "आवश्यक छ";
    }

    if (!values.address) {
      errors.address = mode === "en" ? "Required" : "आवश्यक छ";
    }
 
    if (!values.citizenshipNo) {
      errors.citizenshipNo = mode === "en" ? "Required" : "आवश्यक छ";
    }
   
    if (!values.gender) {
      errors.gender = mode === "en" ? "Required" : "आवश्यक छ";
    }

    if (values.email.length === 0) {
      setEditIsSubmit(true);
    } else if (!regex.test(values.email)) {
      errors.email =
        mode === "en"
          ? "This is not a valid email format"
          : "यो मान्य इमेल ढाँचा होइन";
    }
    if (!values.contact) {
      errors.contact = mode === "en" ? "Required" : "आवश्यक छ";
    } else if (!numv.test(values.contact)) {
      errors.contact = mode === "en" ? "Must be digits" : "अंक हुनुपर्छ";
    } else if (!digits.test(values.contact)) {
      errors.contact = mode === "en" ? "Must be 10 digits" : "10 अंक हुनु पर्छ";
    }
    if (!values.enrollDate) {
      errors.enrollDate = mode === "en" ? "Required" : "आवश्यक छ";
    }
    if (!values.jobType) {
      errors.jobType = mode === "en" ? "Required" : "आवश्यक छ";
    }
   
    if (!values.department) {
      errors.department = mode === "en" ? "Required" : "आवश्यक छ";
    }
    if (!values.designation) {
      errors.designation = mode === "en" ? "Required" : "आवश्यक छ";
    }

    return errors;
  };

  function handleImageChange(e) {
    if (e.target.files && e.target.files[0]) {
      setTypeFile(e.target.files[0].type);
      let reader = new FileReader();

      reader.onload = function (e) {
        setImage(e.target.result);
        setIsUploaded(true);
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  }

  return (
    <>
      <div className="newpopup-body ps-3 pe-3">
        <div className="form-padding">
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div className="row text-start ">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="firstName" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "First Name" : "पहिलो नाम"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="firstName"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="firstName"
                    value={staffFormValue.firstName}
                    onChange={handleChange}
                  />
                  {staffFormError.firstName && (
                    <p className="errormsg">{staffFormError.firstName}</p>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="middleName" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Middle Name" : "बीचको नाम"}
                  </label>
                  <input
                    id="middleName"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="middleName"
                    value={staffFormValue.middleName}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="lastName" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Last Name" : "थर"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="lastName"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="lastName"
                    value={staffFormValue.lastName}
                    onChange={handleChange}
                  />
                  {staffFormError.lastName && (
                    <p className="errormsg">{staffFormError.lastName}</p>
                  )}
                </div>
              </div>
            </div>


            <div className="row text-start ">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="deviceCode" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Device Code" : "डिभाइस कोड"}
                  </label>
                  <input
                    id="deviceCode"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="deviceCode"
                    value={staffFormValue.deviceCode}
                    onChange={handleChange}
                  />
                  {/* {staffFormError.deviceCode && (
                    <p className="errormsg">{staffFormError.deviceCode}</p>
                  )} */}
                </div>
              </div>
              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="userName" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "UserName" : "प्रयोगकर्ता नाम"}{" "}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="userName"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm"
                    name="userName"
                    value={staffFormValue.userName}
                    onChange={handleChange}
                    disabled
                  />
                  {staffFormError.userName && (
                    <p className="errormsg">{staffFormError.userName}</p>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="password" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Password" : "पासवर्ड"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="password"
                    style={{ fontSize: "13px" }}
                    type="password"
                    className="form-control form-control-sm "
                    name="password"
                    value={staffFormValue.password}
                    onChange={handleChange}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="row text-start ">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="email" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Email" : "इमेल"}
                  </label>
                  <input
                    id="email"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="email"
                    value={staffFormValue.email}
                    onChange={handleChange}
                  />
                  {staffFormError.email && (
                    <p className="errormsg">{staffFormError.email}</p>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="contact" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Contact" : "सम्पर्क"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="contact"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="contact"
                    value={staffFormValue.contact}
                    onChange={handleChange}
                  />
                  {staffFormError.contact && (
                    <p className="errormsg">{staffFormError.contact}</p>
                  )}
                </div>
              </div>

                    <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="address" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Address" : "ठेगाना"}{" "}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="address"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm"
                    name="address"
                    value={staffFormValue.address}
                    onChange={handleChange}
                  />
                  {staffFormError.address && (
                    <p className="errormsg">{staffFormError.address}</p>
                  )}
                </div>
              </div>

            </div>


            <div className="row text-start ">

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="citizenshipNo" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Citizenship No." : "नागरिकता नं"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    id="citizenshipNo"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="citizenshipNo"
                    value={staffFormValue.citizenshipNo}
                    onChange={handleChange}
                  />
                  {staffFormError.citizenshipNo && (
                    <p className="errormsg">{staffFormError.citizenshipNo}</p>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="pan" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "PAN" : "प्यान"}
                  </label>
                  <input
                    id="pan"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="pan"
                    value={staffFormValue.pan}
                    onChange={handleChange}
                  />
                  {staffFormError.pan && (
                    <p className="errormsg">{staffFormError.pan}</p>
                  )}
                </div>
              </div>

                      <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="gender" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Gender" : "लिङ्ग"}{" "}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <select
                    class="form-select form-select-sm"
                    aria-label="Default select example"
                    name="gender"
                    value={staffFormValue.gender}
                    onChange={handleChange}
                  >
                    <option disabled value="" selected>
                      {mode === "en" ? "Select Gender" : "लिङ्ग चयन गर्नुहोस्"}
                    </option>
                    <option value="M">
                      {mode === "en" ? "Male" : "पुरुष"}
                    </option>
                    <option value="F">
                      {mode === "en" ? "Female" : "महिला"}
                    </option>
                    <option value="O">
                      {mode === "en" ? "Other" : "अन्य"}
                    </option>
                  </select>
                  {staffFormError.gender && (
                    <p className="errormsg">{staffFormError.gender}</p>
                  )}
                </div>
              </div>


            </div>



            <div className="row text-start ">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="enrollDate" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Enroll Date" : "भर्ना मिति"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
               
                  {dateMode === "np" ? (
                    <Calendar
                      className="form-control form-control-sm pt-0 pb-0 from-date"
                      dateFormat="YYYY/MM/DD"
                      // defaultDate="2010/01/01"
                      theme="default"
                      language="en"
                      onChange={handleEnroll}
                      name="enrollDate"
                      value={staffFormValue.enrollDate}
                      hideDefaultValue={true}
                      placeholder={staffFormValue.enrollDate}
                    />
                  ) : (
                    <input
                      type="date"
                      name="enrollDate"
                      value={staffFormValue.enrollDate}
                      placeholder="Select a Date"
                      className="form-control form-control-sm "
                      onChange={handleChange}
                    />
                  )}
                  {staffFormError.enrollDate && (
                    <p className="errormsg">{staffFormError.enrollDate}</p>
                  )}
                </div>
              </div>

              {/* <div className="col-md-4 col-sm-4 col-lg-4">
                <div className={`form-group ${!notWorking ? "disDate" : ""}`}>
                  <label htmlFor="leaveDate" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Leave Date" : "छोडेको मिति"}
                  </label>
                  {DFlag === "N" ? (
                    <Calendar
                      className="form-control form-control-sm pt-0 pb-0 from-date"
                      dateFormat="YYYY/MM/DD"
                      // defaultDate="2010/01/01"
                      theme="default"
                      language="en"
                      // minDate={getNepaliDate()}
                      // maxDate={getMaxNepaliDate()}
                      onChange={handleLeaveDate}
                      value={staffFormValue.leaveDate}
                      name="leaveDate"
                      hideDefaultValue={true}
                      placeholder={staffFormValue.leaveDate}
                    />
                  ) : (
                    <input
                      type="date"
                      value={staffFormValue.leaveDate}
                      placeholder="Select a Date"
                      className="form-control form-control-sm "
                      onChange={handleChange}
                      disabled={!notWorking}
                    />
                  )}
                  {staffFormError.leaveDate && (
                    <p className="errormsg">{staffFormError.leaveDate}</p>
                  )}
                </div>
              </div> */}

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="jobType" style={{ fontSize: "12px" }}>
                    {mode === "en"
                      ? "Select Job Type"
                      : "कामको प्रकार चयन गर्नुहोस्"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <select
                    class="form-select form-select-sm"
                    aria-label="Default select example"
                    name="jobType"
                    value={staffFormValue.jobType}
                    onChange={handleChange}
                  >
                    <option disabled value="" selected>
                      {mode === "en"
                        ? "Select Job Type"
                        : "कामको प्रकार चयन गर्नुहोस्"}
                    </option>
                    <option value="1">
                      {mode === "en" ? "Full Time" : "पुरै समय"}
                    </option>
                    <option value="2">
                      {mode === "en" ? "Part Time" : "आंशिक समय"}
                    </option>
                    <option value="3">
                      {mode === "en" ? "Intern" : "इन्टर्न"}
                    </option>
                    <option value="4">
                      {mode === "en" ? "Paid Intern" : "भुक्तान गरिएको इन्टर्न"}
                    </option>
                    <option value="5">
                      {mode === "en" ? "Freelance" : "स्वतन्त्र"}
                    </option>
                    <option value="6">
                      {mode === "en" ? "Contract" : "सम्झौता"}
                    </option>
                    <option value="7">
                      {mode === "en" ? "Training" : "प्रशिक्षण"}
                    </option>
                  </select>
                  {staffFormError.jobType && (
                    <p className="errormsg">{staffFormError.jobType}</p>
                  )}
                </div>
              </div>

         

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="department" style={{ fontSize: "12px" }}>
                    {mode === "en"
                      ? "Select Department"
                      : "विभाग चयन गर्नुहोस्"}{" "}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <select
                    class="form-select form-select-sm"
                    aria-label="Default select example"
                    name="department"
                    value={staffFormValue.department}
                    onChange={handleChange}
                  >
                    <option disabled value="" selected>
                      {mode === "en"
                        ? "Select Department"
                        : "विभाग चयन गर्नुहोस्"}
                    </option>

                    {departmentList.map((item) => (
                      <option key={item.DepartmentID} value={item.DepartmentID}>
                        {item.Department}
                      </option>
                    ))}
                  </select>
                  {staffFormError.department && (
                    <p className="errormsg">{staffFormError.department}</p>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="designation" style={{ fontSize: "12px" }}>
                    {mode === "en"
                      ? "Designation"
                      : "पदनाम चयन गर्नुहोस्"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                    <input
                    id="designation"
                    style={{ fontSize: "13px" }}
                    type="text"
                    className="form-control form-control-sm "
                    name="designation"
                    value={staffFormValue.designation}
                    onChange={handleChange}
                  />
                  {staffFormError.designation && (
                    <p className="errormsg">{staffFormError.designation}</p>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-lg-4">
                <div className="form-group">
                  <label htmlFor="branch" style={{ fontSize: "12px" }}>
                    {mode === "en" ? "Select Branch" : "साखा चयन गर्नुहोस्"}
                    <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <select
                    class="form-select form-select-sm"
                    aria-label="Default select example"
                    name="branch"
                    value={staffFormValue.branch}
                    onChange={handleChange}
                  >
                    <option disabled value="" selected>
                      {mode === "en" ? "Select Branch" : "साखा चयन गर्नुहोस्"}
                    </option>

                    {branchList.map((item) => (
                      <option key={item.BranchID} value={item.BranchID}>
                        {item.Name}
                      </option>
                    ))}
                  </select>
                  {staffFormError.branch && (
                    <p className="errormsg">{staffFormError.branch}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group  ">
              <div
                className="form-label"
                htmlFor="text"
                style={{ fontSize: "12px", textAlign: "left" }}
              >
                {mode === "en" ? "Upload Image" : "फोटो अपलोड गर्नुहोस्"}
              </div>

              <div className="BoxUpload">
                <div className="image-upload">
                  {!image ? (
                    <>
                      <label htmlFor="upload-input">
                        <img
                          src={Plus}
                          draggable={"false"}
                          alt="placeholder"
                          style={{ width: 90, height: 100, paddingTop: "10px" }}
                        />
                      </label>

                      <input
                        id="upload-input"
                        type="file"
                        accept=".jpg,.jpeg,.gif,.png,.mov,.mp4"
                        onChange={handleImageChange}
                        name="image"
                      />
                    </>
                  ) : (
                    <div className="ImagePreview">
                      <img
                        className="close-icon"
                        src={CloseIcon}
                        alt="CloseIcon"
                        onClick={() => {
                          setIsUploaded(false);
                          setImage(null);
                        }}
                      />

                      <img
                        id="uploaded-image"
                        src={image}
                        draggable={false}
                        alt="uploaded-img"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="new-footer">
        <div className="row  mt-1 mb-1">
          <div>
            <button
              type="button"
              class="btn btn-sm me-2"
              style={{ background: "var(--button-color)", color: "white" }}
              onClick={formNext}
            >
              {mode === "en" ? "Submit" : "बुझाउनुहोस्"}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-danger me-3"
              style={{ color: "white" }}
              onClick={closePopUp}
            >
              {mode === "en" ? "Cancel" : "बन्द गर्नुहोस्"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
